<template>
    <button type="button" class="icon-button" :aria-label="label" :disabled="disabled" @click="$emit('click')">
        <i :class="icon" aria-hidden="true"></i>
    </button>
</template>

<script>
export default {
    name: 'IconButton',
    props: {
        icon: { type: String, required: true },
        label: { type: String, required: true },
        disabled: { type: Boolean, default: false }
    }
}
</script>

<style lang="scss" scoped>
.icon-button {
    @include display-flex();
    @include align-items(center);
    @include justify-content(center);
    flex-shrink: 0;
    padding: 8px;
    border: none;
    @include border-radius(4px);
    background-color: $main-t90;
    color: $main-dark;
    cursor: pointer;

    i {
        font-size: 20px;
    }

    &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }
}
</style>
